import { Injectable } from '@angular/core';
import { getCurrentUser } from 'app/utils/helpers';
import { PayorEnum } from '../enums/payor.enum';
import { TenantsEnum } from '../enums/tenants.enum';
import { TripReasonTransportEnum } from '../enums/trip-reason-transport.enum';
import { SweetAlertHelper } from './sweet-alert-helper.service';
import { ToastrAlertHelper } from './toastr-alert-helper-service';
import { CustomDate } from './format-date-helper';

@Injectable()
export class ValidationsTripService {
  constructor(
    private sweetAlertHelper: SweetAlertHelper,
    private toastrAlertHelper: ToastrAlertHelper
  ) {}

  onChangeReasonTransport(payorId: number, tripReasonTransportId: number) {
    const payors = [PayorEnum.FreedomHealth, PayorEnum.OptimumHealthcare];
    if (
      getCurrentUser().tenant === TenantsEnum.trip2 &&
      payors.includes(payorId)
    ) {
      if (tripReasonTransportId === TripReasonTransportEnum.Pharmacy) {
        this.sweetAlertHelper.createCustomAlert({
          type: 'warning',
          text: 'Only allowed after a medical appointment',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
      }
    }
  }

  private toMinutes(time: string): number {
    if (!/^\d{1,2}:\d{2}$/.test(time)) {
      return NaN;
    }
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  isPreviousDayPickup(form: { pickup: string; appointment: string }): boolean {
    const { pickup, appointment } = form;

    if (!pickup || !appointment) {
      return false;
    }

    const pickupMinutes = this.toMinutes(pickup);
    const appointmentMinutes = this.toMinutes(appointment);

    const isEveningPickup = pickupMinutes >= 18 * 60;
    const isEarlyMorningAppointment = appointmentMinutes < 6 * 60;
    const pickupTimeExceedsAppointment = pickupMinutes > appointmentMinutes;

    return isEveningPickup && isEarlyMorningAppointment && pickupTimeExceedsAppointment;
  }

  getPickupDate(form: {
    pickup: string;
    appointment: string;
    dateofservice: string;
  }): string | null {
    const { pickup, appointment, dateofservice } = form;
    if (!pickup || !appointment || !dateofservice) {
      return null;
    }
    const pickupMinutes = this.toMinutes(pickup);
    const appointmentMinutes = this.toMinutes(appointment);
    if (pickupMinutes <= appointmentMinutes) {
      return null;
    }
    const OVERNIGHT_THRESHOLD_MINUTES = 720;
    if (pickupMinutes - appointmentMinutes <= OVERNIGHT_THRESHOLD_MINUTES) {
      return null;
    }
    const dosDate = CustomDate.parseLocalDate(dateofservice);
    dosDate.setDate(dosDate.getDate() - 1);
    return dosDate.toISOString();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/validations-trip.service.ts